import { Injectable } from "@angular/core";


@Injectable({
    providedIn: 'root'
})
export class HelperService {
   

    constructor(){}

    getFromLocal(text){
        return localStorage.getItem(text);
     }
 
     setInlocal(text, data){
         return localStorage.setItem(text, JSON.stringify(data));
          
     }

     removeFromLocal(_text){
        localStorage.removeItem(_text);
     }
 
}